export const FILTER_ID_QUERY_PARAM = 'filter';
